import React from 'react';
import {ButtonPreset} from "../../basic-ui-components/button/base/button-props.interface";
import { ISvgIconProps } from '../../basic-ui-components/icon/svg-icon/svg.icon';
import {OverflowProperty} from "../../../common/types/css";

export interface IModalDialogHandler {
    close(shouldApplyClosingAnimation?: boolean, isClosedDirectlyByUser?: boolean): void;
    zIndex: number;
    shouldBeClosedOnlyByUser: boolean;
    shouldApplyClosingAnimation: boolean;
    readonly isHidden: boolean;
    display(): void;
    hide(): void;
}

export interface ShowModalOptions {
    useAutoHeight?: boolean;
    title?: string;
    icon?: React.ComponentType<ISvgIconProps>;
    onClosed?: () => void;
    onClosedByXButton?: ()=> void;
    onHide?: () => void;
    onDisplay?: () => void;
    debugInfo?: string;
    hideBorders?: boolean;
    hideCloseButton?: boolean;
    showOpenAndCloseAnimation?: boolean;
    forceTransparentBackground?: boolean;
    transparentBackgroundOpacity?: number;
    forceTransparentContentBackground?: boolean;
    hideDialogHeader?: boolean;
    forceCentralization?: boolean;
    disableFullscreenMobile?: boolean;
    applyMaxHeight?: boolean;
    mobileCenterHeader?: boolean;
    isHighPriority?: boolean;
    forceZOrder?:number;
    shouldBeClosedOnlyByUser?: boolean;
    forceFullscreenTablet?: boolean;
    headerClass?: string;
    showPopupAboveSecondWebViewHybrid?:boolean;
    noDefaultContentPadding?: boolean;
    renderExtraHeaderButtons?: () => React.ReactElement;
    overflow?: OverflowProperty;
    createAsHidden?: boolean;
}

export enum DialogButtonClickHandleResultEnum {
    CloseDialogAndContinue,
    KeepDialogOpen
}

export interface ISimpleTextModalButtonOptions {
    text: string;
    buttonPreset: ButtonPreset;
    onClick: () => Promise<DialogButtonClickHandleResultEnum>;
}

export interface ISimpleTextModalOptions {
    text: string | string[];
    title?: string;
    /** @deprecated Do not send an icon as a string url or as react element. Use an svg icon in the iconSvg prop */
    icon?: string | React.ReactElement;
    iconSvg?: React.ComponentType<ISvgIconProps>;
    showEmptyTitle?: boolean;
    hideCloseButton?: boolean;
    buttons?: ISimpleTextModalButtonOptions[];
    disableFullscreenMobile?: boolean;
    showPopupAboveSecondWebViewHybrid?: boolean;
    onClosedByXButton?: ()=> void;
    onClosed?: () => void;
}

export interface IDialogService {
    showModal(renderContent: (dialogHandler: IModalDialogHandler) => React.ReactNode, options?: ShowModalOptions): IModalDialogHandler;
    showSimpleTextModal(options: ISimpleTextModalOptions): IModalDialogHandler;
    readonly currentDialogs: React.ReactNode[];
    readonly hasOpenDialogs: boolean;
    getMaxCGPOverlayZIndex(): number;
    closeAllDialogs(): void;
    countDialogs(opts: {includeHidden: boolean;}): number;
}